import React from 'react';
import "./orderfooter.css"

const OrderFooter=()=> {
  return (
    <div className='copyright'>
        <p className='copyright1'>2022 © Laundry</p>
    </div>
    )
}

export default OrderFooter;